
// import {mapGetters} from "vuex"
// import filters from "@/mixins/filters";

export default {
	data() {
    return {
      full: false
    };
  },
	watch:{
		isAll(){
			this.$nextTick(() => {
				this.$refs.tabs.scrollLeft = 0
			})
		}
	},
	props: {
		folders: Array,
		isAll: Boolean
	},
	mounted() {
		this.$nextTick(() => {
			if (localStorage.foldersTabsLeft && this.$device.isMobile && this.$refs.tabs) {
				this.$refs.tabs.scrollLeft = Number(localStorage.foldersTabsLeft)
			}
		})
	},
	computed: {
		sortedFoldersByCount() {
			return this.$_.sortBy(this.folders, [function (folder) {
				return folder.offers_count;
			}]).reverse();
		},
		
	},
	beforeDestroy() {
		localStorage.generationsTabsLeft = 0
	},
	methods: {
		scrollFolders() {
			localStorage.foldersTabsLeft = event.target.scrollLeft
		},
	},
}
